<template>
  <div style="height: 90% !important">
    <template>
      <v-row v-if="!selected_station">
        <!-- <v-col cols="3" class="pt-1 pr-3">
          <v-btn-toggle
            v-model="type_item"
            mandatory
            dense
            color="green darken-3"
            style="width: 100%"
          >
            <v-btn value="product" class="btn-show-mode" style="width: 50%">
              <v-icon
                v-if="type_item == 'product'"
                class="mr-1"
                color="green"
                size="16"
              >
                fas fa-check
              </v-icon>
              PRODUCTOS
            </v-btn>
            <v-btn value="service" class="btn-show-mode" style="width: 100%">
              <v-icon
                v-if="type_item == 'service'"
                class="mr-1"
                color="green"
                size="16"
              >
                fas fa-check
              </v-icon>
              Análisis
            </v-btn>
          </v-btn-toggle>
        </v-col> -->
        <!-- <v-col cols="1" class="pl-0">
          <v-icon
            v-if="type_item == 'service'"
            color="success"
            @click="handleViewCreateService"
          >
            fas fa-plus-circle
          </v-icon>
        </v-col> -->
        <v-col cols="12" class="pt-1 pr-3">
          <v-text-field
            v-model="search_product"
            label="Buscar por nombre, código de barras"
            autofocus
            hide-details
            prepend-inner-icon="mdi-magnify"
            solo
            @keydown="handleInputSearchProduct"
          >
          </v-text-field>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12" class="pt-3 pb-0">
          <v-card class="section-catalogue">
            <v-card-text class="pl-0 pr-0 pt-0 pb-0">
              <template>
                <v-list
                  v-if="type_item == 'product'"
                  two-line
                  dense
                  class="pt-0"
                >
                  <v-list-item
                    v-for="product in catalogue"
                    :key="product.id"
                    class="catalogue-item"
                    @click="handleSelectProduc(product)"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        <span class="font-weight-bold">{{
                          product.description
                        }}</span>
                      </v-list-item-title>
                      <v-list-item-subtitle>
                        <v-icon color="red" class="mr-3" size="12"
                          >fas fa-tag</v-icon
                        >
                        <span class="mr-3 font-italic font-weight-bold"
                          >Stock:</span
                        >
                        <span class="font-weight-bold" v-if="product.stock">
                          {{ product.stock }}
                        </span>
                        <span class="font-weight-bold" v-else> 0 </span>
                      </v-list-item-subtitle>
                    </v-list-item-content>
                    <v-list-item-action>
                      <span class="font-weight-bold">{{
                        product.price | currency("S/")
                      }}</span>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
                <v-list v-else two-line dense class="pt-0">
                  <v-list-item
                    v-for="service in services"
                    :key="service.id"
                    class="catalogue-item"
                    @click="handleSelectProduc(service)"
                  >
                    <v-list-item-content>
                      <v-list-item-title>
                        <span v-if="service.code">{{ service.code }} -</span>
                        <span class="font-weight-bold">
                          {{ service.name }}</span
                        >
                      </v-list-item-title>
                    </v-list-item-content>
                    <v-list-item-action>
                      <span class="font-weight-bold">{{
                        service.base_price | currency("S/")
                      }}</span>
                    </v-list-item-action>
                  </v-list-item>
                </v-list>
              </template>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>

    <v-snackbar v-model="cant_pay" top color="error">
      {{ message_validation }}
      <v-btn dark text @click="handleCloseMessageValidation"> Cerrar </v-btn>
    </v-snackbar>

    <add-quantity ref="addQuantity"></add-quantity>
    <create-service ref="createService"></create-service>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";

import AddQuantity from "../../components/sales/AddQuantity";
import ArrayTools from "../../helpers/ArrayTools";
import { BarCodeSupport } from "@/plugins/BarCodeSupport";
import CreateService from "../services/CreateUpdate";
import ServicesApi from "../../apis/Services";

export default {
  name: "Catalogue",
  components: {
    AddQuantity,
    CreateService,
  },
  data() {
    return {
      category: null,
      search_product: null,
      option_accesories: true,
      option_hardware: false,
      class_modality: "",
      brands: [],
      types: [],
      capacities: [],
      colors: [],
      dialog_chip: false,
      dialog_portabilidad: false,
      unit_id: null,
      type_item: "service",
      data: [],
      cant_pay: false,
      message_validation: null,
    };
  },
  computed: {
    ...mapState("inventories", ["catalogue"]),
    ...mapState("sales", [
      "modality",
      "product",
      "type_operation",
      "cart",
      "company",
      "company_id",
    ]),
    ...mapState("services", ["services"]),
    ...mapState("stations", ["selected_station"]),
  },
  methods: {
    ...mapActions("saleoptions", ["getSalesOptions"]),
    ...mapActions("inventories", [
      "run_set_catalogue",
      "getCatalogue",
      "getCatalogueToSale",
    ]),
    ...mapActions("sales", [
      "add_product_to_cart",
      "select_modality",
      "select_product",
      "replace_product_cart",
    ]),
    ...mapActions("services", ["getServices"]),
    customText(item) {
      let text = item.name;

      return text;
    },
    handleListHardware() {
      this.category = "Hardware";
      this.option_accesories = false;
      this.option_hardware = true;
      this.search_product = null;
      this.searchProductInCatalogue();
    },
    async handleInputSearchProduct(KeyboardEvent) {
      if (KeyboardEvent.code == "Enter") {
        if (this.type_item == "product") {
          this.searchProductInCatalogue();
        } else if (this.type_item == "service") {
          let filterService = {
            name: this.search_product,
          };
          // console.log(filterService);
          this.getServices(filterService);
          //   const response = await ServicesApi.get_all(filterService);
          //   this.data = response.data;
        }
      }
    },
    handleChangeUnit(value) {
      if (value !== undefined && value !== null) {
        this.unit_id = value;
      } else {
        this.unit_id = null;
      }
      this.searchProductInCatalogue();
    },
    handleSelectProduc(product) {
      /*if (this.type_item == 'product') {
                this.select_product(product);
                if (this.product.stock) {
                    if (parseFloat(this.product.stock) > 0) {
                        this.$refs.addQuantity.show();
                    }
                }
            } else if (this.type_item == 'service') {
                let serviceProduct = this.convertServiceAsProduct(product);
                this.select_product(serviceProduct);
                this.$refs.addQuantity.show();
            }*/
      if (product.base_price == null) {
        this.cant_pay = true;
        this.message_validation = "Analisis sin precio";
        return;
      }
      this.addItemToCart(product);
    },
    addItemToCart(product) {
      let serviceProduct = this.convertServiceAsProduct(product);
      this.select_product("service product", serviceProduct);
      let item_action = "add";

      //let productFounded = ArrayTools.existProductInCart(this.cart, serviceProduct.product_id, serviceProduct.type_item);
      let productFounded = serviceProduct;

      let productToAdd = Object.assign({}, this.product);
      let id = new Date().getTime();
      //let quantity = parseFloat(this.form.quantity);
      let quantity = 1;
      let discount_type = null;
      let discount_amount = 0;
      let discount_value = 0;

      if (productFounded) {
        item_action = "add";

        productToAdd = Object.assign({}, productFounded);

        id = productToAdd.id;
        //quantity = parseFloat(this.form.quantity);
        quantity = 1;

        discount_type = productToAdd.discount_type;
        discount_amount = productToAdd.discount_amount;
        discount_value = productToAdd.discount_value;
      }

      let cart_item = {
        id: id,
        inventory_id: productToAdd.inventory_id,
        category_id: productToAdd.category_id,
        category_name: productToAdd.category_name,
        product_id: productToAdd.product_id,
        description: productToAdd.description,
        code: productToAdd.code,
        sub_description: null,
        imei: null,
        number: null,
        modality: null,
        plan_id: null,
        plan_name: null,
        operator: null,
        modality_start: null,
        plan_start: null,
        modality_end: null,
        plan_id_end: null,
        plan_name_end: null,
        quantity: quantity,
        price: parseFloat(productToAdd.price),
        discount_type: discount_type,
        discount_amount: discount_amount,
        discount_value: 0,
        subtotal: quantity * parseFloat(productToAdd.price),
        commission: 0,
        type_item: productToAdd.type_item,
        is_bonus: false,
        worker_id: null,
        note: null,
        monto_base: parseFloat(productToAdd.price),
        monto_convenio: parseFloat(product.monto_convenio),
        detail_price: serviceProduct.detail_price,
      };

      if (this.company_id) {
        const service_price = serviceProduct.detail_price.find(
          (dtp) => dtp.company_id == this.company_id
        );
        if (service_price) cart_item.price = parseFloat(service_price.price);
      }

      if (item_action === "add") {
        if (this.company != null) {
          if (cart_item.monto_convenio > 0) {
            cart_item.price = cart_item.monto_convenio;
          }
          this.add_product_to_cart(cart_item);
        } else {
          this.add_product_to_cart(cart_item);
        }
      } else {
        discount_value = this.calculateDiscountValue(cart_item);
        cart_item.discount_value = discount_value;
        this.replace_product_cart(cart_item);
      }
    },
    calculateDiscountValue(product) {
      let discount_value = 0;
      if (product.discount_type) {
        discount_value = parseFloat(product.discount_amount);
        if (product.discount_type == "Porcentaje") {
          let percentage = parseFloat(product.discount_amount);
          let discount = parseFloat(product.subtotal) * (percentage / 100);
          discount_value = Math.round(discount * 100) / 100;
        }
      }
      return discount_value;
    },
    convertServiceAsProduct(service) {
      return {
        barcode: null,
        brand_name: null,
        category: null,
        category_id: null,
        category_name: null,
        description: service.name,
        code: service.code,
        inventory_id: null,
        price: service.base_price,
        product_id: service.id,
        sku: null,
        stock: null,
        type_item: "service",
        detail_price: service.detail_price,
      };
    },
    searchProductInCatalogue() {
      this.run_set_catalogue([]);
      let filters = {
        category: this.category,
        description: this.search_product,
        unit_id: this.unit_id,
      };
      this.getCatalogueToSale(filters);
    },
    selectBarcode(data) {
      this.search_product = data;
      this.searchProductInCatalogue();
    },
    handleViewCreateService() {
      this.$refs.createService.showForm("REGISTRAR SERVICIO", "create");
    },
    async handleMountComponents() {
      const response = await ServicesApi.get_all({});
      this.data = response.data;
      //   console.log("===>>>>> ::::", response);
    },
    handleContainer() {
      // console.log("===>>>>> ::::");
      // const panelIzquierda = document.getElementById("PanelIzquierda");
      // console.log("=====>>>> ::::", panelIzquierda);
      // console.log("=====>>>> ::::", panelIzquierda.clientWidth);
      // if (document.body.scrollHeight - window.innerHeight === window.scrollY) {
      //   console.log("estoy en el final del scroll");
      // }
    },
    handleCloseMessageValidation() {
      this.cant_pay = false;
      this.message_validation = null;
    },

    // window.addEventListener('scroll', onScroll)
  },
  created() {
    this.run_set_catalogue([]);
    // this.handleListHardware();
    // this.handleMountComponents();
    this.getServices();
  },
  mounted() {
    BarCodeSupport.$on("codeScanned", (data) => {
      this.selectBarcode(data);
    });
  },
};
</script>

<style scoped>
.selected-option {
  color: #ffffff !important;
  background-color: #023145 !important;
}

.selected-option > .v-card__text > span {
  color: #ffffff !important;
  background-color: #023145 !important;
}

.section-catalogue {
  height: 83vh;
  overflow-y: auto;
}

.catalogue-item {
  text-transform: uppercase;
  border-bottom: 1px solid #e0e0e0;
  min-height: 50px !important;
}

.btn-product-category {
  display: inline-block !important;
  width: 100%;
}

.sale-option-label {
  font-size: 0.8rem !important;
  font-weight: 600;
}

.option-img {
  padding-left: 15%;
  padding-top: 12px;
}

.label-modality {
  padding-left: 15% !important;
}

.sale-option-img {
  background-color: #023145; /* #00908b;*/
  color: #ffffff;
  width: 83%;
  height: 40px;
  padding-top: 5px;
  border-radius: 4px;
  text-align: center;
}

.btn-modality {
  height: 80px !important;
  width: 114px !important;
  /*margin: auto;*/
}

.modality-select {
  background-color: #ffe330;
}

.frm-portabilidad {
  border: 1px solid;
}
</style>
